import { Colore } from "./Colore";
import { Fase } from "./Fase";
import { InnerRigaDistinta } from "./InnerRigaDistinta";
import { VariazioneRigaDistinta } from './VariazioneRigaDistinta';
import { RigaDistintaQtaTaglia } from './RigaDistintaQtaTaglia';
import { StatoSyncRigaDistinta } from './RigaDistinta'
import { StatoVariazioneRigaDistinta } from '.';
import { RigaDistintaPerComunicazioneVariazione } from './VariazioneDaComunicare';

export interface RigaInValidazione {
    id: string;    
    idDistintaAppartenenza: string;
    indiceRiga: number;
    innerRigaDistinta: InnerRigaDistinta;
    coloreDecodificato: Colore;
    faseDecodificata: Fase;
    quantitaPerTaglia?: RigaDistintaQtaTaglia[];

    // Dati storici e consumi in caso di riga in distinta statica
    indiceVariazioneAttiva: number;
    variazioniComunicate?: VariazioneRigaDistinta[];
    statoSincronizzazioneVariazione?: StatoSyncRigaDistinta;
    contieneVariazioniDaValidare: boolean;
    variazioneGenerataDaValidazione: boolean;
    inAttesaDiSincronizzazione: boolean;
    conVariazioniConsolidate: boolean;
    richiestaDiInserimento: boolean;
    eliminataDaAs400: boolean;
    righeCorrelate: RigaInValidazione[];
    mostraCorrelate: boolean;
}

// export const RigaDistintaHelper = {
//     variazioneInAttesaSync(riga: RigaDistinta | RigaDistintaPerComunicazioneVariazione): boolean {
//         let modificaInAttesaSync = riga.inAttesaDiSincronizzazione;
        
//         let inserimentoInAttesaSync = false;
//         if(riga.contieneVariazioniDaValidare && riga.variazioniComunicate != undefined && riga.variazioniComunicate.length > 0) {
//             let ultimaVariazione = riga.variazioniComunicate[riga.variazioniComunicate.length -1];
//             inserimentoInAttesaSync = ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore || ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDaBC;
//         }
    
//         return modificaInAttesaSync || inserimentoInAttesaSync;
//     },
//     isNuova(riga: RigaDistinta) {
        
//         // TODO: sostituire con il check di stato quando lato server sarà omogeneo
//         //return riga.statoSincronizzazioneVariazione != 'NEW'; 
        
//         if(riga.contieneVariazioniDaValidare && riga.variazioniComunicate != undefined && riga.variazioniComunicate.length > 0) {
//             let ultimaVariazione = riga.variazioniComunicate[riga.variazioniComunicate.length -1];
//             let statoNuova = ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore || ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDaBC;
  
//             return statoNuova;
//         }
  
//         return false;
//     }
// }